export default "__VITE_ASSET__BnEqHKQ5__"